import { getLanguagePrefixedPath } from './homepageUrl';

/**
 * App path to the cookies policy page for the active language.
 */
export const getCookiesPolicyPath = (pathname, locale) =>
  getLanguagePrefixedPath(pathname, locale, '/cookies');

export default getCookiesPolicyPath;
